import React from 'react';

/** Section divider band — e.g. "⚡ Vibrancy Points ───── subtitle" */
export const SectionDivider: React.FC<{ icon: string; title: string; note: string }> = ({ icon, title, note }) => (
    <div className="d-flex align-items-center gap-2 my-2 text-uppercase fw-medium font-14 text-secondary">
        <span style={{ fontSize: 14 }}>{icon}</span>{title}
        <div className="flex-grow-1" style={{ height: 1, background: '#e1e8f5' }}></div>
        <span className="text-lowercase fw-normal font-13">{note}</span>
    </div>
);

/** Coloured rounded-square card-header icon. */
export const HeaderIcon: React.FC<{ icon: string; bg: string; color: string }> = ({ icon, bg, color }) => (
    <span className="d-inline-flex align-items-center justify-content-center rounded-2"
        style={{ width: 26, height: 26, background: bg, color, fontSize: 13 }}>{icon}</span>
);

/** Avatar circle with initials. */
export const Avatar: React.FC<{ initials: string; bg: string; color: string; size?: number }> = ({ initials, bg, color, size = 30 }) => (
    <div className="rounded-circle d-flex align-items-center justify-content-center fw-bold flex-shrink-0"
        style={{ width: size, height: size, background: bg, color, fontSize: size > 32 ? 13 : 11 }}>{initials}</div>
);

/** label · bar · value progress row used across many cards. */
export const BarRow: React.FC<{ label: React.ReactNode; right: React.ReactNode; color: string; width: number; dot?: boolean }> = ({ label, right, color, width, dot = true }) => (
    <div className="mb-2">
        <div className="row g-1">
            <div className="col">
                <div className="d-flex flex-wrap align-items-center gap-2">
                    {dot && <span className="rounded-circle p-1" style={{ background: color }}></span>}
                    <small className="text-truncate" style={{ maxWidth: 290 }}>{label}</small>
                </div>
            </div>
            <div className="col-auto"><small className="fw-medium">{right}</small></div>
            <div className="col-12">
                <div className="progress flex-grow-1" style={{ height: 5 }}>
                    <div className="progress-bar" style={{ width: `${width}%`, background: color }}></div>
                </div>
            </div>
        </div>
    </div>
);

export const cardStyle = { borderColor: '#e1e8f5' } as React.CSSProperties;
export const cardHeaderStyle = { borderColor: '#e1e8f5' } as React.CSSProperties;
